<ng-container *ngIf="!string_filter && baseDatasourceVariant.isTableLoaded && baseDatasourceVariant.totalItem$.getValue() === 0; else elseBlock" cardBody>
  <app-card-empty icon="{{ iconNone }}" text="Belum terdapat data product variant."></app-card-empty>
</ng-container>

<ng-template #elseBlock>
  <!-- note view: cant get stock info; gudang not assigned to area -->
  <app-note-view
    [text]="'Untuk mendapatkan informasi stock, silahkan assign gudang ke Area.'"
    [icon]="STRING_CONSTANTS.ICON.IC_INFO"
    [color]="'info-secondary'"
    *ngIf="!hasWarehouseSubject.value"
  ></app-note-view>

  <!-- begin::Card -->
  <app-card [cardBodyClasses]="'pt-2'" [header]="true">
    <!--begin::Card header-->
    <ng-container cardHeader>
      <app-input-search
        (actionFilter)="onSearch($event)"
        [isFinishLoadingSubject]="baseDatasourceVariant.isFinishLoadingSubject"
        [placeholder]="'Cari Nama Varian Produk'"
        [value]="string_filter"
      ></app-input-search>
    </ng-container>
    <!--end::Card header-->
    <!--begin::Card body-->
    <ng-container cardBody>
      <ng-container *ngIf="string_filter && baseDatasourceVariant.isTableLoaded && baseDatasourceVariant.totalItem$.getValue() === 0; else elseFilterBlock" cardBody>
        <app-card-empty icon="{{ iconNone }}" text="Belum terdapat data product variant."></app-card-empty>
      </ng-container>
      <ng-template #elseFilterBlock>
        <div class="table-responsive">
          <table [dataSource]="baseDatasourceVariant" class="table w-100 gy-5 table-row-bordered align-middle" mat-table matSort>
            <ng-container *ngFor="let tableColumn of tableColumns; index as i" [matColumnDef]="tableColumn.key">
              <ng-container *ngIf="tableColumn.isSortable; else notSortTable">
                <th
                  *matHeaderCellDef
                  [arrowPosition]="'after'"
                  [class.min-w-200px]="tableColumn.key !== 'actions' && tableColumn.key !== 'id'"
                  [mat-sort-header]="tableColumn.key"
                  class="min-w-125px px-3"
                  mat-header-cell
                >
                  <div *ngIf="baseDatasourceVariant.isFinishLoadingSubject.value">
                    {{ tableColumn.title }}
                  </div>
                  <div *ngIf="!baseDatasourceVariant.isFinishLoadingSubject.value">
                    <app-table-content [width]="70"></app-table-content>
                  </div>
                </th>
              </ng-container>
              <ng-template #notSortTable>
                <th
                  *matHeaderCellDef
                  [class.min-w-200px]="tableColumn.key !== 'actions' && tableColumn.key !== 'id'"
                  [ngClass]="{
                    'min-w-70px text-center': tableColumn.key === 'actions',
                    'w-250px': tableColumn.key === 'alamat'
                  }"
                  class="min-w-125px px-3"
                  mat-header-cell
                >
                  <div *ngIf="tableColumn.key === 'available_stock'" class="d-flex info-header-detail-products">
                    <div *ngIf="baseDatasourceVariant.isFinishLoadingSubject.value">
                      {{ tableColumn.title }}
                    </div>
                    <div *ngIf="!baseDatasourceVariant.isFinishLoadingSubject.value">
                      <app-table-content [width]="180"></app-table-content>
                    </div>
                    <span
                      *ngIf="baseDatasourceVariant.isFinishLoadingSubject.value"
                      [inlineSVG]="STRING_CONSTANTS.ICON.IC_INFO"
                      class="ms-2 cursor-pointer"
                      ngbPopover="Jumlah stok yang tersedia untuk diorder"
                      placement="bottom"
                      popoverClass="tooltip-info-product text-primary"
                    ></span>
                  </div>
                  <div *ngIf="baseDatasourceVariant.isFinishLoadingSubject.value && tableColumn.key !== 'available_stock'">
                    {{ tableColumn.title }}
                  </div>
                  <div *ngIf="!baseDatasourceVariant.isFinishLoadingSubject.value && tableColumn.key !== 'available_stock'">
                    <app-table-content [width]="180"></app-table-content>
                  </div>
                </th>
              </ng-template>
              <td *matCellDef="let element" class="px-3" mat-cell>
                <ng-container [ngSwitch]="tableColumn.key">
                  <div *ngSwitchCase="'actions'" class="text-center">
                    <button
                      [ngClass]="{
                        'is-download': element['is_download']
                      }"
                      class="btn btn-table-actions-download"
                    >
                      <app-table-content [isFinishLoadingSubject]="baseDatasourceVariant.isFinishLoadingSubject" [type]="'icon'">
                        <span (click)="handleAction(element['product_id'])" [inlineSVG]="STRING_CONSTANTS.ICON.IC_ACTIONS_TABLE"></span>
                      </app-table-content>
                    </button>
                  </div>
                  <div *ngSwitchCase="'product_name'">
                    <app-table-content [isFinishLoadingSubject]="baseDatasourceVariant.isFinishLoadingSubject">
                      <div class="d-flex gap-3">
                        <img
                          *ngIf="element['product_image']"
                          alt="{{ element['product_name'] }}"
                          class="image-varian-list img-thumbnail shadow border-0"
                          src="{{ element['product_image'] }}"
                        />
                        <span class="my-auto">{{ element[tableColumn.key] ?? '-' }} </span>
                      </div>
                    </app-table-content>
                  </div>
                  <div *ngSwitchCase="'available_stock'">
                    <app-table-content [isFinishLoadingSubject]="baseDatasourceVariant.isFinishLoadingSubject">
                      <button *ngIf="element['is_have_warehouse']; else noWarehouseTpl" class="btn bg-transparent btn-text border-0 p-0" (click)="handleInfoVariantStock(element)">
                        <span class="text-decoration-underline text-primary">Lihat detail</span>
                      </button>
                      <ng-template #noWarehouseTpl>
                        <span class="svg-icon svg-icon-2" [inlineSVG]="STRING_CONSTANTS.ICON.IC_DANGER"></span>
                      </ng-template>
                    </app-table-content>
                  </div>
                  <div *ngSwitchCase="'price_per_box'">
                    <app-table-content [isFinishLoadingSubject]="baseDatasourceVariant.isFinishLoadingSubject">
                      <div>
                        {{ utilities.toRupiah(element[tableColumn.key]) }}
                      </div>
                    </app-table-content>
                  </div>
                  <div *ngSwitchCase="'price_unit'">
                    <app-table-content [isFinishLoadingSubject]="baseDatasourceVariant.isFinishLoadingSubject">
                      <div>
                        {{ utilities.toRupiah(element[tableColumn.key]) }}
                      </div>
                    </app-table-content>
                  </div>
                  <div *ngSwitchDefault>
                    <app-table-content [isFinishLoadingSubject]="baseDatasourceVariant.isFinishLoadingSubject">
                      <span>{{ element[tableColumn.key] ?? '-' }} </span>
                    </app-table-content>
                  </div>
                </ng-container>
              </td>
            </ng-container>

            <tr *matHeaderRowDef="displayedColumns" class="fw-bold text-start text-uppercase" mat-header-row></tr>
            <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
          </table>
        </div>
        <div class="d-flex justify-content-between py-4 bottom_paginated_transparent_variant_information">
          <app-mai-material-bottom-table
            (changePage)="changePageEvent($event)"
            [baseDataTableComponent]="baseDatasourceVariant"
            [isFinishLoadingSubject]="baseDatasourceVariant.isFinishLoadingSubject"
            class="w-100"
          ></app-mai-material-bottom-table>
        </div>
      </ng-template>
    </ng-container>
    <!--end::Card body-->
  </app-card>
  <!-- end::Card -->
</ng-template>

<!--begin::Modal-->
<app-modal #modalDetail [modalConfig]="modalDetailConfig" [modalOptions]="modalDetailOption">
  <div class="d-flex w-100 justify-content-between flex-column">
    <div cardBody class="d-flex w-100 justify-content-between detail-modal-variants">
      <div class="d-flex align-items-center justify-content-center flex-column left-section">
        <div *ngIf="isLoading">
          <div class="w-100">
            <div class="w-100 d-flex align-items-center justify-content-center flex-column">
              <app-skeleton-text [height]="244" [isLoading]="isLoading" [width]="244"></app-skeleton-text>
              <div class="d-flex flex-row">
                <div *ngFor="let item of counter(5)" class="px-2">
                  <app-skeleton-text [height]="56" [isLoading]="isLoading" [width]="56"></app-skeleton-text>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-100 d-flex align-items-center flex-column">
          <div class="d-flex justify-content-center align-items-center img-fluid" style="min-height: 244px; height: auto">
            <img *ngIf="DetailVariantData.value" [src]="urlPreview.value" alt="image" class="img-fluid" style="width: 300px; height: 244px" />
          </div>
          <div *ngIf="imageList.value.length > 1" class="w-100 paginator-group">
            <div (click)="slidePrev()" *ngIf="imageList.value.length >= 3" [inlineSVG]="STRING_CONSTANTS.ICON.IC_ANGLE" class="swiper-button"></div>
            <div class="w-100 swiper-body-product-detail">
              <swiper #swiperVariant [config]="config" [slidesPerView]="3" [spaceBetween]="10" class="d-flex w-100">
                <ng-template *ngFor="let item of imageList.value" swiperSlide>
                  <div (click)="onClickImagePreview(item)" class="border-primary image-container cursor-pointer {{ item === urlPreview.value && 'active' }}">
                    <img alt="image" height="56" src="{{ item }}" style="white-space: nowrap" width="56" />
                  </div>
                </ng-template>
              </swiper>
            </div>
            <div (click)="slideNext()" *ngIf="imageList.value.length >= 3" [inlineSVG]="STRING_CONSTANTS.ICON.IC_ANGLE" class="swiper-button button-next"></div>
          </div>
        </div>
      </div>
      <div>
        <h1>{{ titleVariant.value }}</h1>
        <div *ngFor="let item of DetailVariantData.value" class="row mt-4 mb-3">
          <label class="col-lg-6 text-gray-400">{{ item.key }}</label>
          <div class="col-lg-6">
            <span class="text-gray-800">: {{ item.value }}</span>
          </div>
        </div>
      </div>
    </div>
    <!--      Old-->
  </div>
</app-modal>

<app-modal
  #modalInfoStock
  [modalConfig]="{
    showHeader: false,
    showFooter: false,
    modalTitle: 'Stock ' + variantStockSubject.value.name
  }"
>
  <ng-container *ngIf="variantStock$ | async as variantStock; else loaderTpl">
    <ng-container *ngIf="variantStock.errors as err; else stockListTpl">
      <!-- show err code -->
      <div class="bg-gray-100 rounded rounded-1 p-2 mb-7" *ngIf="reFetchCounter < 1">
        <span>Error code: {{ err[0].code }}</span>
      </div>

      <!-- show err msg fail get data-->
      <ng-container *ngIf="reFetchCounter > 0">
        <ng-template [ngTemplateOutlet]="reFetchButton"></ng-template>
      </ng-container>

      <ng-container *ngIf="reFetchCounter < 1">
        <ng-template [ngTemplateOutlet]="reFetchButtonDisabled" [ngTemplateOutletContext]="{ msg: err[0].message }"></ng-template>
      </ng-container>
    </ng-container>

    <!--  STOCK LIST  -->
    <ng-template #stockListTpl>
      <ul class="list-unstyled" *ngIf="variantStockSubject.value.list.length; else loaderTpl">
        <li *ngFor="let item of variantStockSubject.value.list" class="mb-2">
          <div class="d-flex align-items-center">
            <span class="col-6 text-uppercase">{{ item['name'] }}</span>
            <span class="col text-gray-900">: {{ utilities.toNumberFormat(item['stock']) }}</span>
          </div>
        </li>
      </ul>
    </ng-template>
  </ng-container>

  <ng-template #reFetchButton>
    <app-note-view [color]="'danger'" [text]="'Gagal mendapatkan informasi stok dari ERP. Silahkan coba lagi.'" [extraContent]="true" [icon]="STRING_CONSTANTS.ICON.IC_DANGER">
      <div class="ms-8">
        <button class="btn btn-primary btn-sm" (click)="reFetchAvailableStock()">Coba lagi</button>
      </div>
    </app-note-view>
  </ng-template>

  <ng-template #reFetchButtonDisabled let-msg="msg">
    <app-note-view [color]="'danger'" [text]="msg" [icon]="STRING_CONSTANTS.ICON.IC_DANGER"></app-note-view>
  </ng-template>

  <ng-template #loaderTpl>
    <div class="d-flex justify-content-center align-items-center my-7">
      <mat-spinner></mat-spinner>
    </div>
  </ng-template>
</app-modal>
<!--end::Modal-->
